<div class="no-data-found">
    <img [ngClass]="{'dashboard-img': dataToDisplay[1]== 'true'}"src="../../../../assets/images/no-data-graph.svg" *ngIf="dataToDisplay[0] == 'true'">
    <img [ngClass]="{'dashboard-img': dataToDisplay[1] == 'true'}" src="../../../../assets/images/no-data.svg" *ngIf="dataToDisplay[0] == 'false'">
    <h5>{{title}}</h5>
    <div class="margin-block"><a href="{{dataToDisplay[3]}}" class="link-modal">{{dataToDisplay[2]}}</a> 
        {{dataToDisplay[4]}}</div>
</div>
